import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  formElementWrapper: {
    paddingRight: 10,
    paddingLeft: 10,
    marginTop: 10,
    marginBottom: 10,
    maxWidth: 435,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  fullWidth: {
    maxWidth: 'none',
  }
}))


export const FormElementWrapper = props => {

  const classes = useStyles();

  const Component = props.component ? props.component : 'div';

  return (
    <Component className={`form-element-wrapper ${classes.formElementWrapper} ${props.fullWidth ? classes.fullWidth : ''} ${props.className ? props.className : ''}`}>
      {props.children}
    </Component>
  )
}